import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Caricamento...
        </h2>
        <p className="text-gray-600">
          Verifica dello stato di autenticazione in corso
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;